import React from 'react';
import { MapContainer, TileLayer, ZoomControl } from 'react-leaflet';
import { Layers, Search } from 'lucide-react';
import { Input } from '../components/ui/Input';
import { Button } from '../components/ui/Button';
import { TemperatureLegend } from '../components/map/TemperatureLegend';
import { TimelineControls } from '../components/map/TimelineControls';
import 'leaflet/dist/leaflet.css';
export function MapView() {
  return <div className="jua-page-bg relative h-[calc(100vh-64px)] w-full overflow-hidden group" data-id="element-2533">
      {/* Map */}
      <MapContainer center={[20, 0]} zoom={3} className="h-full w-full z-0 bg-[#0B1120]" zoomControl={false} attributionControl={false} data-id="element-2534">
        <TileLayer url="https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png" attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>' data-id="element-2535" />
        <ZoomControl position="topright" data-id="element-2536" />
      </MapContainer>

      {/* Weather Overlay Simulation */}
      <div className="absolute inset-0 pointer-events-none z-[1] opacity-60 mix-blend-overlay" style={{
      background: `
            linear-gradient(180deg, 
              rgba(11, 17, 32, 0.8) 0%, 
              rgba(59, 130, 246, 0.3) 20%, 
              rgba(34, 197, 94, 0.3) 40%, 
              rgba(234, 179, 8, 0.4) 50%, 
              rgba(239, 68, 68, 0.3) 60%, 
              rgba(59, 130, 246, 0.3) 80%, 
              rgba(11, 17, 32, 0.8) 100%
            )
          `
    }} data-id="element-2537" />

      {/* Search Overlay */}
      <div className="absolute top-6 left-6 z-[1000] w-[320px]" data-id="element-2538">
        <Input placeholder="Search for places..." className="bg-[#1E293B]/90 backdrop-blur border-slate-700/50 h-11 shadow-xl" data-id="element-2539" />
      </div>

      {/* Layers Toggle */}
      <div className="absolute top-6 right-6 z-[1000] mr-12" data-id="element-2540">
        <Button size="icon" className="rounded-full bg-[#1E293B]/90 backdrop-blur border border-slate-700/50 hover:bg-slate-800 shadow-xl" data-id="element-2541">
          <Layers size={20} className="text-slate-300" data-id="element-2542" />
        </Button>
      </div>

      {/* Bottom Controls */}
      <TemperatureLegend data-id="element-2543" />
      <TimelineControls data-id="element-2544" />
    </div>;
}